import React from 'react';
import { Shield, Lock, Key, AlertTriangle } from 'lucide-react';
import { SEO } from '../lib/seo';

const Security: React.FC = () => {
  return (
    <>
      <SEO 
        title="Seguridad | Electricista Barcelona"
        description="Información sobre nuestras medidas de seguridad, certificaciones y protocolos de trabajo seguros."
        canonical="/security"
        type="website"
      />
      
      <div className="py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-8">Seguridad</h1>

          <div className="prose max-w-none">
            <section className="mb-12">
              <div className="flex items-center gap-2 mb-4">
                <Shield className="w-6 h-6 text-yellow-500 flex-shrink-0" />
                <h2 className="text-2xl font-bold">Certificaciones y Autorizaciones</h2>
              </div>
              
              <div className="space-y-4">
                <p>
                  Como instalador eléctrico autorizado, contamos con todas las certificaciones necesarias para garantizar un servicio seguro y profesional:
                </p>
                <ul className="list-disc list-inside space-y-2">
                  <li>Carnet de instalador eléctrico autorizado</li>
                  <li>Registro en la Dirección General de Industria</li>
                  <li>Seguro de responsabilidad civil profesional</li>
                  <li>Certificaciones de seguridad laboral</li>
                </ul>
              </div>
            </section>

            <section className="mb-12">
              <div className="flex items-center gap-2 mb-4">
                <Lock className="w-6 h-6 text-yellow-500 flex-shrink-0" />
                <h2 className="text-2xl font-bold">Protocolos de Seguridad</h2>
              </div>

              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-bold mb-2">Equipos de Protección</h3>
                  <p className="mb-4">
                    Utilizamos equipos de protección individual (EPI) homologados:
                  </p>
                  <ul className="list-disc list-inside space-y-2">
                    <li>Guantes dieléctricos certificados</li>
                    <li>Calzado de seguridad aislante</li>
                    <li>Herramientas con aislamiento</li>
                    <li>Gafas de protección</li>
                    <li>Ropa de trabajo ignífuga</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-2">Procedimientos de Trabajo</h3>
                  <ul className="list-disc list-inside space-y-2">
                    <li>Evaluación previa de riesgos</li>
                    <li>Verificación de ausencia de tensión</li>
                    <li>Señalización de zonas de trabajo</li>
                    <li>Protocolos de bloqueo y etiquetado</li>
                    <li>Procedimientos de trabajo en altura</li>
                  </ul>
                </div>
              </div>
            </section>

            <section className="mb-12">
              <div className="flex items-center gap-2 mb-4">
                <Key className="w-6 h-6 text-yellow-500 flex-shrink-0" />
                <h2 className="text-2xl font-bold">Normativa y Cumplimiento</h2>
              </div>

              <div className="space-y-4">
                <p>
                  Cumplimos estrictamente con toda la normativa aplicable:
                </p>
                <ul className="list-disc list-inside space-y-2">
                  <li>Reglamento Electrotécnico de Baja Tensión (REBT)</li>
                  <li>Normativa de Prevención de Riesgos Laborales</li>
                  <li>Normas UNE aplicables</li>
                  <li>Ordenanzas municipales</li>
                </ul>

                <div className="bg-yellow-50 p-6 rounded-lg mt-4">
                  <h4 className="font-bold mb-2">Actualizaciones Continuas</h4>
                  <p>
                    Mantenemos una formación continua para estar al día de las últimas normativas y técnicas de seguridad en instalaciones eléctricas.
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-12">
              <div className="flex items-center gap-2 mb-4">
                <AlertTriangle className="w-6 h-6 text-yellow-500 flex-shrink-0" />
                <h2 className="text-2xl font-bold">Gestión de Emergencias</h2>
              </div>

              <div className="space-y-4">
                <p>
                  Contamos con protocolos específicos para situaciones de emergencia:
                </p>
                <ul className="list-disc list-inside space-y-2">
                  <li>Procedimientos de primeros auxilios</li>
                  <li>Protocolos de evacuación</li>
                  <li>Contactos de emergencia</li>
                  <li>Equipos de extinción de incendios</li>
                </ul>

                <div className="bg-yellow-50 p-6 rounded-lg mt-4">
                  <h4 className="font-bold mb-2">Respuesta 24/7</h4>
                  <p>
                    Disponemos de un servicio de emergencias 24 horas para responder ante cualquier incidencia eléctrica urgente.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Compromiso con la Seguridad</h2>
              <p className="mb-4">
                La seguridad es nuestra máxima prioridad. Nos comprometemos a:
              </p>
              <ul className="list-disc list-inside space-y-2">
                <li>Mantener los más altos estándares de seguridad</li>
                <li>Realizar evaluaciones de riesgo exhaustivas</li>
                <li>Proporcionar formación continua a nuestro personal</li>
                <li>Utilizar materiales y equipos homologados</li>
                <li>Documentar y revisar todos los procedimientos de seguridad</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default Security;